import { Breakpoint, Color, FontWeight, hexToRgba, Icon } from '@elearning-platform/ui';
import { css, RuleSet, styled } from 'styled-components';

import { Button } from '../../../../components/button/button.component';
import { ReactComponent as TrashSvg } from '../../../../images/trash.svg';

import { DateProps, IconContainerProps, StyledIconProps } from './notification.types';

export const Container = styled.div`
  padding: 20px 30px 20px 20px;
  background-color: ${Color.White};
  margin-bottom: 2px;
  width: 100%;
  text-align: left;
  box-shadow: 0 5px 10px ${hexToRgba(Color.Gray800, 0.01)};

  @media ${Breakpoint.Tablet} {
    padding: 38px 45px 38px 35px;
  }
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;

export const IconWrapper = styled.div`
  width: 32px;
  height: 32px;
  flex-shrink: 0;

  @media ${Breakpoint.SmallDesktop} {
    width: 40px;
    height: 40px;
  }
`;

export const TitleContainer = styled.div`
  display: flex;
  gap: 20px;

  @media ${Breakpoint.SmallDesktop} {
    gap: 40px;
  }
`;

export const TitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-right: 20px;
`;

export const Title = styled.p`
  font-weight: ${FontWeight.SemiBold};
  font-size: 14px;
  line-height: 20px;
  color: ${Color.Gray700};
  margin-bottom: 2px;
`;

export const DateInfo = styled.div`
  display: flex;
  align-items: center;
`;

export const Date = styled.span<DateProps>`
  font-size: 13px;
  line-height: 17px;
  color: ${Color.Gray500};
  ${({ $isUnread }: DateProps): RuleSet | false => !!$isUnread && css`
    color: ${Color.Brand300};
    font-weight: ${FontWeight.Bold};
  `}
`;

export const StyledIcon = styled(Icon)<StyledIconProps>`
  transform: rotate(90deg);
  cursor: pointer;
  transition: transform 0.2s cubic-bezier(0.25, 0.1, 0.25, 1);
  ${({ $isRotated }: StyledIconProps): string | false => !!$isRotated && 'transform: rotate(0deg)'};
`;

export const Dot = styled.div`
  width: 5px;
  height: 5px;
  background-color: ${Color.Brand300};
  margin-right: 5px;
  border-radius: 50%;
`;

export const Content = styled.div``;

export const ContentInner = styled.div`
  margin-top: 20px;
  margin-left: 0;

  @media ${Breakpoint.Tablet} {
    margin-left: 80px;
  }
`;

export const Text = styled.p`
  max-width: 680px;
  font-size: 14px;
  line-height: 24px;
  color: ${Color.Gray700};

  a {
    color: ${Color.Brand300};
    font-weight: ${FontWeight.Bold};
  }
`;

export const TrashButton = styled.button`
  margin-top: 20px;
  cursor: pointer;
`;

export const TrashIcon = styled(TrashSvg)`
  width: 14px;
  height: 18px;
  fill: ${Color.Brand300};
`;

export const DeleteButton = styled(Button)`
  margin-top: 20px;
  width: calc(100% + 10px);
  color: ${Color.Brand300};
`;

export const IconContainer = styled.div<IconContainerProps>`
  width: 100%;
  height: 100%;
  ${({ $isAward }: IconContainerProps): RuleSet | false => !$isAward && css`
    border: 1px solid ${Color.Gray300};
    border-radius: 3px;
    display: flex;
    align-items: center;
    justify-content: center;
    
    svg {
      path {
        fill: ${Color.Gray300};
      }
    }
  `}
`;

export const LoaderContainer = styled.div`
  margin-top: 10px;
`;
